import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=28929f34&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28929f34')) {
      api.createRecord('28929f34', component.options)
    } else {
      api.reload('28929f34', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=28929f34&", function () {
      api.rerender('28929f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2964XSr8RjISn/JS/cancellationPolicy.vue"
export default component.exports